import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import Config from '../../../../Config';
import { connect } from 'react-redux';
import Payment from '../Partials/Payment/Payment';
import PopUpPaymentError from '../Partials/Payment/PopUpPaymentError/PopUpPaymentError';
import SuccessMsg from '../Partials/Payment/SuccessMsg/SuccessMsg';
import ErrorMsg from '../Partials/Payment/ErrorMsg/ErrorMsg';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { resetCgIframeUrl, reportDWH, setIsDisplayPopupForHelp } from '../energySaleBlockSlice';
import { getEMVStep1, getEMVStep2, createSale } from '../energySaleBlockAsyncThunk';
import { gtag4 } from '../../../../utilities/analytics/tracking';


const PaymentPage = (props) => {
  const [isDisplayErrorPopup, setIsDisplayErrorPopup] = useState(false);
  const [errorPopupContent, setErrorPopupContent] = useState('');
  const [step, setStep] = useState('payment');
  const [isDisplayFooter, setIsDisplayFooter] = useState(false);

  //page params
  let btnText = 'סיימתי';
  let currentPageFunction = handlePageContinue;
  const formid = 'energySaleBlock';
  var handler;
  //page params

  useExtendedEffect((runSideEffects) => {
    getCgUrl();
    gtag4({
      event: 'Energy_Step8_CreditCardPage',
      step: '8',
      action: 'CreditCardPage',
      funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
    });
    props.reportDWH({ actionType: 'Payment Page', status: 'Ongoing', messageText: 'Payment Page - Displayed' })
    if (!runSideEffects()) {
    }
  }, []);


  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      {
        step == 'payment' &&
        <>
          <h1 className='energy-sale-title'>עדכון אמצעי תשלום לחשבון החדש</h1>
          <h2 className='energy-sale-sub-title'>הכרטיס ישמש לחיוב החשמל החודשי לאחר הניוד</h2>
        </>
      }
      {
        step == 'loader' &&
        <>
          <h1 className='energy-sale-title'>אוטוטו מסיימים</h1>
        </>
      }
      {
        step == 'success' &&
        <>
          <h1 className='energy-sale-title'>אוטוטו מסיימים</h1>
        </>
      }
      {
        step == 'error' &&
        <>
          <h1 className='energy-sale-title'>השלמת הזמנה</h1>
        </>
      }
    </div>
  );

  let currentPageView = (
    <div>
      {step == 'payment' && <Payment iframeUrl={props.iframeUrl} />}
      {step == 'success' && <SuccessMsg termsLink={props.termsLink}/> }
      {step == 'error' && <ErrorMsg onclickTryAgainBtn={getCgUrl} />}
      <PopUpPaymentError isDisplayErrorPopup={isDisplayErrorPopup} content={errorPopupContent} closePopUp={closePopUp} onclickTryAgainBtn={onclickTryAgainBtn} />
    </div>
  );

  return (
    <>
    <div className='energy-sale-content-wrapper'>
      {currentPageHeadline}
      <div className='energy-sale-page-content width-340'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
      </div>
    </div>
    <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} formid={formid} />
    </>
  );

  async function getCgUrl() {
    setIsDisplayFooter(false);
    setStep('payment');
    props.getEMVStep1();
    addEventListener();
  }

  async function getCgConfirmation(token, identity) {
    setStep('loader');
    const result = await props.getEMVStep2({ token: token, id: identity });
    if (result.payload.returnCode == '00') {
      setIsDisplayFooter(true);
      setStep('success');
    }
    else {
      setStep('error');
    }
  }

  function closePopUp() {
    setIsDisplayErrorPopup(false);
  }

  function onclickTryAgainBtn() {
    getCgUrl();
    setIsDisplayErrorPopup(false);
  }

  function handlePageContinue() {
    gtag4({
      event: 'Energy_Step8_CreditCardClick',
      step: '8',
      action: 'CreditCardClick',
      funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
    });
    props.reportDWH({ actionType: 'Payment Page', status: 'Ongoing', messageText: 'Payment Page - Clicked' })
    props.createSale();
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  function addEventListener() {
    //listen to iframe messages from cg
    var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';

    handler = function (e) {
      var isSuccess = e.data.status == 'success';
      var isError = e.data.status == 'error';

      if (isSuccess) {
        props.resetCgIframeUrl();
        if (Config.cgShowIdNumber == "True" && (props.identity != "" && e.data.personalId != props.identity)) {
          setErrorPopupContent('תעודת הזהות שהזנתם לא תואמת לפרטים איתם הזדהתם בתחילת התהליך.');
          setIsDisplayErrorPopup(true);
        }
        else {
          getCgConfirmation(e.data.token, e.data.personalId);
        }
        removeListener();
      }
      else if (isError) {
        props.resetCgIframeUrl();
        setErrorPopupContent('האשראי שהוזן לא תואם לבעל תעודת זהות או שהזנתם מספר כרטיס אשראי שגוי.');
        setIsDisplayErrorPopup(true);
        removeListener();
      }
      return;
    };

    eventer(messageEvent, handler);
  }

  function removeListener() {
    var cond = window.addEventListener;
    window[cond ? 'removeEventListener' : 'detachEvent'](cond ? 'message' : 'onmessage', handler);
  }

};

const mapStateToProps = (state) => {
  return {
    identity: state.energySaleBlock.otpDetails.identityNumber,
    termsLink: state.energySaleBlock.energySaleBlockData.termsLink,
    iframeUrl: state.energySaleBlock.paymentInfo.iframeUrl,
    isStartWithSelectedPackage: state.energySaleBlock.isStartWithSelectedPackage
    //other states
  };
};

const mapDispatchToProps = {
  getEMVStep1,
  getEMVStep2,
  createSale,
  resetCgIframeUrl,
  reportDWH,
  setIsDisplayPopupForHelp
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPage);
